import React, { useCallback, useEffect, useState } from "react";
import { useAuth } from "../../context/AuthContext";
import DataTable from "./DataTable";
import { useLocation, useNavigate } from "react-router-dom";
import { activateUser, blockUser, getUsersList } from "../../services/User";
import { listPremiumAccountUserIdsAdmin } from "../../services/Premium";
import { InputTypeConstants } from "../../constants";
import InfoPopup from "./InfoPopup";

const calculateOperations = (user) => {
  let operations = [2, 0, 0]; // Status operacji: Edytuj, Aktywuj, Blokuj
  // 0 - ukryte, 1 - wyłączone, 2 - włączone
  if (user.Active) operations = [2, 0, 2];
  if (!user.Active) operations = [1, 2, 0];

  return operations;
};

const UserList = () => {
  const { accessToken, userId } = useAuth();
  const [users, setUsers] = useState();
  const [infoPopupTrigger, setInfoPopupTrigger] = useState(0);
  const [infoPopupTitle, setInfoPopupTitle] = useState("");
  let navigate = useNavigate();

  const location = useLocation();

  const itemsPerPage = 10;
  const columnHeaders = [
    "Nazwisko",
    "Imię",
    "Email",
    "Izba",
    "Aktywny",
    "Data utworzenia",
    "Operacje",
  ];
  const dataColumns = [
    "LastName",
    "FirstName",
    "Email",
    "Chamber",
    "Active",
    "CreateDate",
    "Id",
  ];
  const actionNames = ["Edytuj", "Aktywuj", "Blokuj"];

  const fetchData = useCallback(async () => {
    const [tempUsers, premiumUserIds] = await Promise.all([
      getUsersList(accessToken),
      listPremiumAccountUserIdsAdmin(accessToken),
    ]);
    const premiumUserIdSet = new Set(
      (premiumUserIds || []).map((id) => String(id)),
    );
    let usersWithOperations = [];
    (tempUsers || []).forEach((user) => {
      let userWithOperation = {
        ...user,
        Premium: premiumUserIdSet.has(String(user.Id)),
        Operations: calculateOperations(user),
      };
      usersWithOperations.push(userWithOperation);
    });

    setUsers(usersWithOperations);
  }, [accessToken]);

  const activateUserHandler = async (userId) => {
    if (await activateUser(userId, accessToken)) {
      fetchData();
    }
  };

  const blockUserHandler = async (userId) => {
    if (await blockUser(userId, accessToken)) {
      fetchData();
    }
  };

  const editUserHandler = (userId) => {
    navigate("/user/edit/" + userId, { replace: true });
  };

  const actionHandlers = [
    editUserHandler,
    activateUserHandler,
    blockUserHandler,
  ];

  useEffect(() => {
    fetchData();
  }, [userId, location.state?.__refresh, fetchData]);

  useEffect(() => {
    const message = location.state?.userFeedback;
    if (!message) return;

    setInfoPopupTitle(message);
    setInfoPopupTrigger((current) => current + 1);

    const nextState = { ...(location.state || {}) };
    delete nextState.userFeedback;
    navigate(location.pathname, { replace: true, state: nextState });
  }, [location.pathname, location.state, navigate]);

  const filters = [
    {
      name: "Nazwisko",
      type: InputTypeConstants.TEXT,
    },
    {
      name: "Imię",
      type: InputTypeConstants.TEXT,
    },
    {
      name: "Email",
      type: InputTypeConstants.TEXT,
    },
    {
      name: "Izba",
      type: InputTypeConstants.TEXT,
    },
    {
      name: "Aktywny",
      type: InputTypeConstants.CHECKBOX,
    },
    {
      name: "Data utworzenia",
      type: InputTypeConstants.DATE,
    },
  ];

  return (
    <>
      <InfoPopup title={infoPopupTitle} trigger={infoPopupTrigger} />
      <div className="card container-fluid shadow ms-4 px-4 py-3 w80">
        <div className="d-flex flex-column w72">
          <div>W tym widoku możesz zarządzać użytkownikami systemu.</div>
          <div className="ms-auto pb-3">
            <button
              className="btn btn-primary"
              style={{ width: "140px" }}
              onClick={() => {
                navigate("/user/add", { replace: true });
              }}
            >
              Dodaj
            </button>
          </div>
        </div>

        {users && (
          <DataTable
            data={users}
            itemsPerPage={itemsPerPage}
            columnCount={columnHeaders.length - 1}
            columnHeaders={columnHeaders}
            dataColumns={dataColumns}
            actionNames={actionNames}
            actionHandlers={actionHandlers}
            initialSortColumn="Nazwisko"
            customFilters={filters}
            rowPrefixRenderer={(row) =>
              row._raw?.Premium ? (
                <i
                  className="bi bi-award-fill text-warning align-middle"
                  title="Aktywne konto VIP"
                  aria-label="Aktywne konto VIP"
                ></i>
              ) : null
            }
          />
        )}
      </div>
    </>
  );
};

export default UserList;
